
const ListTable = require('app/ui/list/Table');

class AverageMarginView {

    defaultOptions(){
        return {
            'tabId': 'averageMarginTab',
            'graphTabLinkId': 'averageMarginGraphLinkTab',
            'graphTabId': 'averageMarginGraphTab',
            'dataTabLinkId': 'averageMarginDataLinkTab',
            'dataTabId': 'averageMarginDataTab',
            '$container': null,
            'data': null,
            'product': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.data = this.settings.data;
        this.product = this.settings.product;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$container
        .html('')
        .append(this.buildHeader())
        .append(this.buildContent());

        this.fillContent();
    }

    buildHeader(){
        let $header = $("<h3/>")
        .addClass('box-title')
        .append(window.translate('app.product.show.tabs.stat.averageMarginView.title'))

        return $header;
    }

    buildContent(){
        this.$dataContent = $('<div/>');

        let $content = $('<div/>')
        .addClass('p-2')
        .append(this.$dataContent);

        return $content;
    }

    fillContent(){
        let total = 0;
        let totalRatio = 0;
        let count = 0;
        for(var i in this.data){
            let value = this.data[i].y;
            let ratio = this.data[i].y2;
            total += value;
            totalRatio += ratio;
            if(value){
                count++;
            }
        }
        let average = total / count;
        let averageRatio = totalRatio / count;
        if(isNaN(average) || count <= 0){
            average = 0;
            averageRatio = 0;
        }

        let $footerContent = $("<tr/>")
        .append(
            $('<th/>')
            .append(window.translate('average'))
        )
        .append(
            $('<th/>')
            .append(window.formatFloat(average) + ' &euro;')
        )
        .append(
            $('<th/>')
            .append(window.formatFloat(averageRatio) + ' %')
        );

        this.table = new ListTable({
            '$container': this.$dataContent,
            'tableClass': 'table table-striped',
            'id': 'ordercount-list',
            'length': 0,//unlimited
            'data': this.data,
            'footerContent': $footerContent,
            'columns': [
                {
                    'name': 'month',
                    'label': window.translate('month'),
                    'class': 'margin-month',
                    'render': function(item,index){
                        let splitedMonth = item.x.split('-');
                        let monthLabel = window.translate('month'+parseInt(splitedMonth[1]));
                        return monthLabel + ' ' + splitedMonth[0];
                    },
                },
                {
                    'name': 'total',
                    'label': window.translate('total'),
                    'class': 'margin-total',
                    'render': function(item,index){
                        return window.formatFloat(item.y) + ' &euro;';
                    },
                },
                {
                    'name': 'ratio',
                    'label': window.translate('ratio'),
                    'class': 'margin-ratio',
                    'render': function(item,index){
                        return window.formatFloat(item.y2) + ' %';
                    },
                }
            ]
        });
    }

}

module.exports = AverageMarginView;

